import { Notification } from '@domain'

import api from '.'
import { NotificationsListReq } from './notifications.types'

export const NotificationsKeys = {
	all: ['notifications'],
	list: (query: NotificationsListReq) => [...NotificationsKeys.all, query.readStatus],
}

const NotificationsApi = {
	list: (query: NotificationsListReq) =>
		api
			.get<PaginatedAPIRes<Notification[]>>('/notifications', { params: query })
			.then((res) => res.data),
	markRead: (id: Id) =>
		api.post<APIRes<Notification>>(`/notifications/${id}/mark-read`).then((res) => res.data.data),
	markUnread: (id: Id) =>
		api.post<APIRes<Notification>>(`/notifications/${id}/mark-unread`).then((res) => res.data.data),
	markAllRead: () =>
		api.post<APIRes<Notification[]>>('/notifications/mark-read').then((res) => res.data.data),
}

export default NotificationsApi
